import { Dimensions } from 'utils';

const mapDimensionsToQsParams = (filters?: Dimensions[]): string => {
    return !filters?.length
        ? ''
        : filters.map(({ id, type }) => `filter[${type}][]=${id}`).join('&');
};

export default mapDimensionsToQsParams;
